import { getFeatureFlagsClient } from '@atlassian/mpac-feature-flags';
import { keysToCamelCase } from '@atlassian/mpac-utils/object';

import { getCurrentDeployedBranch, isBranchDeployment } from 'common/utils/branchDeploy';
import ldAnonymousId from './ldAnonymousId';

import type { ApplicationConfig } from '../application-config/types/BootstrapConfig';
import type { AmktBootstrap } from '@atlassian/mpac-api-client';
import type { MarketplaceFeatureFlags } from '@atlassian/mpac-feature-flags';
import type AnalyticsWebClient from '@atlassiansox/analytics-web-client';

type GetFeatureFlagsArgs = {
  amktBootstrap: AmktBootstrap;
  analyticsClient: AnalyticsWebClient;
  applicationConfig: ApplicationConfig;
  sourceQueryParam: string;
};

export const getFeatureFlags = async ({
  amktBootstrap,
  analyticsClient,
  applicationConfig,
  sourceQueryParam,
}: GetFeatureFlagsArgs): Promise<MarketplaceFeatureFlags> => {
  const { ldUserKey: userId } = amktBootstrap;
  const {
    featureFlags: { apiKey, environment },
  } = applicationConfig;

  const client = await getFeatureFlagsClient({
    apiKey,
    // @ts-expect-error [MC-2850] - TS2322 - Type '"staging" | "dev" | "prod"' is not assignable to type 'EnvironmentType'.
    environment,
    userId,
    analyticsClient,
    productKey: 'marketplace',
    customAttributes: {
      source: sourceQueryParam,
      ldAnonymousId: ldAnonymousId.get(),
      ...(isBranchDeployment() && {
        useFrontendBranch: getCurrentDeployedBranch(),
      }),
    },
  });

  const allFlags: MarketplaceFeatureFlags = keysToCamelCase(client.getAllFlags().toJS());

  return allFlags;
};
